<template>

    <panel-navigation>

      <dialog-add-business ref="dialogAddBusiness" :is_agency="true"></dialog-add-business>

      <div class="float-right ml-5 -mt-1" v-if="!fetchingBusinesses && businesses.length > 0">
        <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddBusiness.show()" style="margin-top: 4px"><i class="fa fa-plus mr-2"> </i> ADD AGENCY</div>
      </div>

      <h1 class="text-lg font-semibold mb-3">Agencies</h1>

      <hr class="border-b border-gray-100 mb-3">

      <v-skeleton-loader v-if="fetchingBusinesses" type="article, article, article"></v-skeleton-loader>

      <div class="dashboard-box" v-if="!fetchingBusinesses && businesses.length == 0">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3">

            <br /><br /><br /><br />

            <div class="dashboard-box-iconsquare">
              <div class="dashboard-box-icon-background"></div>
              <div class="dashboard-box-icon">
                <i class="mdi mdi-briefcase-outline"></i>
              </div>
            </div>

            <div style="text-align: center;">
              <div class="pt-2 pb-2">
                <strong>No Businesses Yet</strong>
              </div>

              <div class="text-sm mb-4 text-gray-600">
                You have no businesses yet. Use our tools to add businesses.
              </div>

              <br />

              <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer" @click="$refs.dialogAddBusiness.show()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"></i> ADD NEW BUSINESS</div>
            </div>
            
            <br /><br /><br /><br /><br />
          </div>
        </v-card>
      </div>

      <template v-if="!fetchingBusinesses && businesses.length > 0">
        <div v-if="$vuetify.breakpoint.mobile" class="mt-7">
              <div class="flex flex-row flex-wrap mb-4">
                <div
                        v-for="business in businesses"
                        :key="business.id"
                        class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-4"
                >
                    <v-card class="pa-2" tile>
                        <div class="p-3">
                            <div class="dashboard-box-iconsquare">
                                <div class="dashboard-box-icon-background"></div>
                                <div class="dashboard-box-icon">
                                    <i class="mdi mdi-widgets-outline"></i>
                                </div>
                            </div>

                            <div style="text-align: center">
                                <div class="pt-2 pb-2">
                                    <strong
                                    ><a
                                      href="javascript: void(0);" @click="manageAccount(business)"
                                    ><span class="text-gray-900">{{
                                        business.company_name
                                        }}</span></a></strong>
                                </div>

                                <div v-if="profile.settings.role != 'Manager (readonly)'">
                                    <div class="text-sm mb-6 text-gray-600">
                                        {{ formatDate(business.created_at) }} ·
                                        {{ business.email }}
                                    </div>

                                    <div
                                            class="border-1 custom-bordered-button bg-white w-full text-purple text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer"
                                            @click="manageAccount(business)"
                                            style="margin-top: -5px"
                                    >
                                        <i class="fa fa-code mr-2"></i> MANAGE ACCOUNT
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
          </div>
          
        <div v-else class="dashboard-box">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
              <div v-if="profile.settings.role != 'Manager (readonly)'" class="justify-between items-start mb-3 float-right">
                <v-menu
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="flex flex-row items-center px-4 py-2 rounded border-1 border-gray-500 text-xs text-gray-600 cursor-pointer">
                      <span class="mr-2">Actions</span>
                    </div>
                  </template>

                  <v-list class="table-menu-actions">
                    <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="bulkDelete()"><span class="table-menu-action-icon"><i class="fa fa-trash"></i></span> Delete</a></v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <br clear="all" />

              <div class="" style="margin-top: -50px;">

                <v-data-table
                  :headers="headers"
                  :items="businesses"
                  :items-per-page="20"
                  class="rg-datatable elevation-1"
                  :footer-props="{
                  itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                  showFirstLastPage: true
                  }"
                  mobile-breakpoint="10"
                  :search="search"
                  item-key="id"
                  show-select
                  v-model="selected"
                  >
                      <template v-slot:top>
                        <v-text-field
                          clearable
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                          v-model="search"

                          class="white border border-white"
                          style="width: 100%; max-width: 300px; margin-bottom: 10px;"
                        ></v-text-field>
                      </template>
                  
                      <template v-slot:item.email="{ item }">
                        {{ item.email ? item.email : '-' }}
                      </template>

                      <template v-slot:item.max_locations="{ item }">
                        <v-text-field
                          type="number"
                          style="width: 80px;"
                          outlined
                          dense
                          hide-details
                          v-model="item.max_locations"
                          @input="changeMaxLocations(item, item.max_locations)"
                        >
                        
                        </v-text-field>
                      </template>

                      <template v-slot:item.created_at="{ item }">
                        {{ formatDate(item.created_at) }}
                      </template>

                      <template v-slot:item.id="{ item }">
                        <a href="javascript: void(0);" class="text-xs font-semibold rounded cursor-pointer" @click="manageAccount(item)">
                          <i class="fa fa-sign-in-alt mr-2 text-purple"></i>
                          <span class="whitespace-no-wrap text-purple">Manage ACCOUNT</span>
                        </a>
                      </template>
                  </v-data-table>
            </div>
          </div>
          </v-card>
        </div>
      </template>

    </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import dialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'
import moment from 'moment'

export default {
  metaInfo () {
    return {
      title: "Agencies | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    dialogAddBusiness
  },
  data() {
    return {
      selected: [],
      selectedBusinessIds: [],

      search: "",
   
      headers: [
        { text: 'Name', value: 'company_name' },
        { text: 'Email', value: 'email' },
        { text: 'Max Locations', value: 'max_locations' },
        { text: 'Joined Date', value: 'created_at' },
        { text: '', value: 'id', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState({
      businesses: state => state.businesses.businesses,
      fetchingBusinesses: state => state.businesses.fetchingBusinesses,
      me: state => state.me.me,
      profile: state => state.me.profile
    }),
    sortedBusinesses() {
      return this.businesses.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    }
  },
  methods: {

    changeMaxLocations(user, max_locations) {
      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/change-max-locations`, {
        uuid: user.uuid,
        max_locations: max_locations
      }, {
      headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
      }
      }).then(function() {
          
      });
    },

    checkResetPassword(user) {
            let self = this;

            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: "No",
                showLoading: true,
                html: "This action will reset <strong>" + user.company_name + "'s</strong> password and will send their new login via email.",
            }).then(function(result) {
                if (result.isConfirmed) {
                    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/reset-password`, {
                        uuid: user.uuid
                    }, {
                    headers: {
                        'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                    }
                    }).then(function() {
                        self.$swal({
                            title: "Password Reset!",
                            text: "Password reset and email to the user successfully!",
                            showCancelButton: false,
                        });
                    });
                }
            });
        },

    async bulkDelete() {
      let self = this

      if (self.selectedBusinessIds.length == 0)
        return;

      let selectedNames = [];

      for (var i in this.businesses) {
        if (self.selectedBusinessIds.includes(this.businesses[i].id))
          selectedNames.push(this.businesses[i].company_name)
      }

      this.$swal({
          title: "Are you sure?",
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Yes',
          cancelButtonText: "No",
          html: "The following agencies will be permanently deleted: <br /><br /><strong>" + selectedNames.join("<br />") + "</strong>",
        }).then(function(result) {

          if (result.isConfirmed) {
            console.log(self.selectedBusinessIds)
            self.$store.dispatch('businesses/bulkDelete', {businessesIds: self.selectedBusinessIds})

            setTimeout(function() {
              self.$store.dispatch('businesses/fetch')
              self.selected = []
              self.selectedBusinessIds = []
              self.$store.dispatch('locations/fetch')
              
              if (self.me.company_type == 'agency')
                self.$store.dispatch('stats/fetch')
            }, 1000);
          }

        });
    },

    async manageAccount(business) {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?id=${business.id}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), admin: true, admin_jwt_token: btoa(this.$store.state.auth.jwt) }});
      // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt);
    },

    async manageLocations(business) {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?id=${business.id}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt) + "&redirect=locations";
      this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt), redirect: "locations" }});
    },

    async disableAccess(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/disable-access`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')
    },

    async enableAccess(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-access`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')
    },

    async enableFreeAccess(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/enable-free-access`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')
    },

    async removeFreeAccess(business) {
      this.$store.state.businesses.fetchingBusinesses = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-free-access`, {
          id: business.id
        },
        {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$store.dispatch('businesses/fetch')
    },

    formatDate(date) {
      return moment(date).format("MMM D, YYYY")
    },

    getFreeSignupUrl() {
      return window.location.origin + "/signup";
    },

    // getFreeSignupUrl(plan) {
    //   return window.location.origin + "/signup/plan/" + plan.product_price_free_id.replace("price_", "");
    // },

    onCopy: function (e) {
      this.$swal({
        title: "Copied",
        text: "URL copied successfully!",
        showCancelButton: false,
        });
    },
    onError: function (e) {
      alert('Failed to copy the URL to the clipboard')
      console.log(e);
    },
  },
  mounted() {
    this.$store.state.businesses.fetchingBusinesses = true
    this.$store.dispatch('businesses/fetch')

    let self = this
    setTimeout(function() {
      if (self.me.company_type != 'agency') {
        self.$router.push('/dashboard')
      }
    }, 1000);
  },
  watch: {
    selected: {
      handler() {
        this.selectedBusinessIds = [];

        for (var i in this.selected) {
          this.selectedBusinessIds.push(this.selected[i].id);
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  
</style>
